import styled from 'styled-components'
import { View } from 'react-native'

export const RowLayout = styled(View)`
  flex-direction: row;
`

export const ColumnLayout = styled(View)`
  flex-direction: column;
`
